export default {
  data() {
    return {
      project: {
        email: "",
      },
    };
  },
  created() {},
  methods: {
    getProjektData(user_company_id) {
      let select = {};
      select.getType = "getProjektData";
      select.user_company_id = user_company_id;
      this.$store
        .dispatch("apiPost", select)
        .then((resp) => {
          if (resp.data.project) {
            this.project = resp.data.project;
          }
        })
        .catch((err) => {
          this.$log.error(err);
        });
    },
    isMobile() {
      if (screen.width < 600) {
        return true;
      } else {
        return false;
      }
    },
  },
};
